import { Box, Divider, Grid, Paper, Skeleton } from '@mui/material';

const ActivationSkeleton = () => {
  return (
    <Paper
      elevation={1}
      sx={{
        width: '100%',
      }}
    >
      <Grid
        xs={12}
        container
        display={'flex'}
        justifyContent={'space-between'}
        p={2}
      >
        <Grid container>
          {/* header section */}
          <Grid xs={6}>
            <Box>
              <Skeleton variant="text" width="15%" height={40} />
              <Skeleton variant="text" width="10%" height={40} />
              <Skeleton variant="text" width="20%" height={30} />
            </Box>
          </Grid>
          <Grid xs={6}>
            <Box>
              <Skeleton variant="text" width="10%" height={40} />
              <Skeleton variant="text" width="30%" height={55} />
            </Box>
          </Grid>
        </Grid>
      </Grid>
      <Divider />
      <Grid xs={12} container p={2} gap={2}>
        {/* demographics section */}
        <Grid xs={12} display={'flex'} justifyContent={'space-between'}>
          <Grid xs={2}>
            <Skeleton variant="text" width="60%" height={40} />
          </Grid>
          <Grid xs={10}>
            <Grid
              xs={2}
              display={'flex'}
              justifyContent={'space-between'}
              gap={2}
            >
              <Grid xs={6}>
                <Skeleton variant="text" width="60%" height={40} />
                <Skeleton variant="text" width="100%" height={40} />
              </Grid>
              <Grid xs={6}>
                <Skeleton variant="text" width="60%" height={40} />
                <Skeleton variant="text" width="100%" height={50} />
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {/* country section */}
        <Grid xs={12} display={'flex'} justifyContent={'space-between'}>
          <Grid xs={2}>
            <Skeleton variant="text" width="60%" height={40} />
          </Grid>
          <Grid xs={10}>
            <Grid
              xs={2}
              display={'flex'}
              justifyContent={'space-between'}
              gap={2}
            >
              <Grid xs={6}>
                <Skeleton variant="text" width="60%" height={40} />
                <Skeleton variant="text" width="100%" height={40} />
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {/* people who match section */}
        <Grid xs={12} display={'flex'} justifyContent={'space-between'}>
          <Grid xs={2}>
            <Skeleton variant="text" width="60%" height={40} />
          </Grid>
          <Grid xs={10}>
            <Grid
              xs={6}
              display={'flex'}
              justifyContent={'space-between'}
              gap={2}
            >
              <Grid xs={12} gap={2}>
                <Grid xs={2} gap={2}>
                  <Skeleton variant="text" width="100%" height={40} />
                </Grid>
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  border={1}
                  borderColor="gray"
                  borderRadius={1}
                  p={1}
                  mt={2}
                  gap={2}
                >
                  {Array.from({ length: 6 }, (_, index) => (
                    <Skeleton
                      key={index}
                      variant="text"
                      width="60%"
                      height={40}
                    />
                  ))}
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default ActivationSkeleton;
